/* lua.js generated code 0.3.0 */

var BagButton = xClass("BagButton", function () {
    return cc.CSLoader.createNode("cocos/homeScene_bag_btn.csb")
})
BagButton.prototype.ctor = function () {
    let self = this;
    self.init()
}
BagButton.prototype.init = function () {
    var self = this
    let oldBtn = self.getChildByName("bg")
    let pos = oldBtn.getPosition()
    oldBtn.setPosition(pos.x-3, pos.y - 10)
    var btn = UIButton.create(oldBtn, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenBag))
    self.btn = btn

    let label = self.getChildByName("txt")
    let newText = cc.LabelTTF.create('背包', FONT_DEF.sidebox)
    newText.x = -1
    newText.y = -47
    label.removeFromParent(true)
    self.addChild(newText, 2, "txt")
}
BagButton.prototype.onOpenBag = function () {
    var self = this
    // require("clover/panel/PropBagPanel").create().popup(true)
    require("clover/panel/PropBagPanel").show()
}
// BagButton.create = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var self = this
//     var instance = BagButton.new()
//     assert(instance)
//     if (instance) {
//         instance.init()
//     }
//     return instance
// }
module.exports = BagButton
